export { default as OtherActions } from './OtherActions';
export { default as TeacherImage } from './TeacherImage';
export { default as TeacherInfo } from './TeacherInfo';

